module.exports = __webpack_public_path__ + "img/registerimage1.6fe87f7f.png";